import { Routes } from '@angular/router';

import { HelpButtonsComponent } from './Components/help-buttons/help-buttons.component';

export const routes: Routes = [
    { path: '', component: HelpButtonsComponent }
];